import { Component } from '@theme/component';

/**
 * Kundenservice v2 contact form. Choosing a topic shows that topic's
 * suggested answers and makes the order number required when the topic
 * needs it. A suggested answer opens the page's customer-faq section with
 * the question as search query.
 *
 * @typedef {Object} Refs
 * @property {HTMLSelectElement} [topicSelect]
 * @property {HTMLInputElement} [orderInput]
 * @property {HTMLElement[]} [suggestions]
 *
 * @extends {Component<Refs>}
 */
class KsContactForm extends Component {
  connectedCallback() {
    super.connectedCallback();
    this.#sync();
  }

  selectTopic = () => {
    this.#sync();
    window.phCapture?.('kundenservice_contact_topic_selected', { topic: this.refs.topicSelect?.value || null });
  };

  /** @param {Event} event */
  openAnswer = (event) => {
    const button = event.target;
    if (!(button instanceof HTMLElement)) return;
    const search = button.dataset.faqSearch;
    if (!search) return;

    document.dispatchEvent(new CustomEvent('customer-faq:open', { detail: { search } }));
    window.phCapture?.('kundenservice_contact_answer_clicked', {
      topic: this.refs.topicSelect?.value || null,
      question: search,
    });
  };

  #sync() {
    const option = this.refs.topicSelect?.selectedOptions[0];
    const topicId = option?.dataset.topicId ?? '';

    for (const panel of this.refs.suggestions ?? []) {
      panel.hidden = panel.dataset.topicId !== topicId;
    }

    const orderInput = this.refs.orderInput;
    if (orderInput) {
      // No topic chosen yet → keep it required, the safe default.
      orderInput.required = option?.dataset.requireOrder !== 'false';
    }
  }
}

if (!customElements.get('ks-contact-form')) {
  customElements.define('ks-contact-form', KsContactForm);
}
